import { jsxs, jsx } from 'react/jsx-runtime';
import { AlertDialog, AlertDialogTrigger, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription, AlertDialogFooter, AlertDialogCancel, AlertDialogAction } from '../ui/alert-dialog.js';
import { Button } from '../ui/button.js';
import { useDevice } from '../../contexts/DeviceContext.js';
import { cn } from '../../lib/utils.js';

const MessageDialog = ({
  type = "alert",
  title,
  trigger,
  open,
  openChange,
  children,
  onConfirm,
  onCancel,
  cancelBtnLabel = "취소",
  okBtnLabel = "확인",
  errCode,
  guideDesc,
  onCloseAutoFocus
}) => {
  const { isDesktop } = useDevice();
  return /* @__PURE__ */ jsxs(AlertDialog, { open, onOpenChange: openChange, children: [
    /* @__PURE__ */ jsx(AlertDialogTrigger, { asChild: true, children: trigger }),
    /* @__PURE__ */ jsxs(AlertDialogContent, { className: cn(isDesktop && "max-w-[380px]"), onCloseAutoFocus, children: [
      /* @__PURE__ */ jsxs(AlertDialogHeader, { className: "p-8 pb-0 mb-8 text-center", children: [
        /* @__PURE__ */ jsx(AlertDialogTitle, { className: cn(!title || title === "" && "hidden"), children: title }),
        /* @__PURE__ */ jsx(AlertDialogDescription, { asChild: true, children: /* @__PURE__ */ jsx("div", { className: "whitespace-pre-line", children }) }),
        /* @__PURE__ */ jsx("div", { className: "whitespace-pre-line body-lg text-basic-02", children: guideDesc }),
        /* @__PURE__ */ jsx("div", { className: "eng-body-md text-state-disabled-04", children: errCode })
      ] }),
      /* @__PURE__ */ jsxs(AlertDialogFooter, { children: [
        type === "confirm" && /* @__PURE__ */ jsx(AlertDialogCancel, { asChild: true, children: /* @__PURE__ */ jsx(Button, { className: "flex-1 whitespace-normal leading-none", variant: "line", size: "lg", onClick: onCancel, children: cancelBtnLabel }) }),
        /* @__PURE__ */ jsx(AlertDialogAction, { asChild: true, autoFocus: false, children: /* @__PURE__ */ jsx(
          Button,
          {
            className: cn("flex-1 whitespace-normal leading-none"),
            variant: "line",
            size: "lg",
            onClick: onConfirm,
            children: okBtnLabel
          }
        ) })
      ] })
    ] })
  ] });
};

export { MessageDialog };
